import React from 'react';
import { Link } from 'react-router-dom';
import { ShoppingCart, Star } from 'lucide-react';
import { formatPrice } from '../data/assets';
import { useCart } from '../context/CartContext';
import { useToast } from '../hooks/use-toast';

const ProductCard = ({ product }) => {
  const { addToCart } = useCart();
  const { toast } = useToast();
  const img = (product.images && product.images[0]) || '';

  const handleAdd = (e) => {
    e.preventDefault();
    addToCart(product);
    toast({ title: 'Added to cart', description: product.name });
  };

  return (
    <Link to={`/product/${product.id}`}
      className="group bg-white rounded-2xl border border-gray-100 overflow-hidden card-hover flex flex-col">
      <div className="relative bg-[#f6faf7] p-5 aspect-square flex items-center justify-center overflow-hidden">
        {product.featured && (
          <span className="absolute top-3 left-3 z-10 bg-[#f5a623] text-white text-[11px] font-bold px-2.5 py-1 rounded-full flex items-center gap-1">
            <Star size={11} fill="white" /> Featured
          </span>
        )}
        <img src={img} alt={product.name} loading="lazy"
          className="max-h-full max-w-full object-contain group-hover:scale-110 transition-transform duration-500" />
      </div>
      <div className="p-4 flex flex-col flex-1">
        <span className="text-[11px] font-semibold text-[#37b34a] uppercase tracking-wide">{product.category}</span>
        <h3 className="font-head font-semibold text-[15px] text-[#14181b] mt-1 line-clamp-2 group-hover:text-[#0f7a37] transition-colors">{product.name}</h3>
        <div className="mt-auto pt-3 flex items-center justify-between">
          <span className="text-lg font-bold text-[#0d5228]">{formatPrice(product.price)}</span>
          <button onClick={handleAdd}
            className="nl-btn bg-[#0f7a37] hover:bg-[#0d5228] text-white w-9 h-9 rounded-full">
            <ShoppingCart size={16} />
          </button>
        </div>
      </div>
    </Link>
  );
};

export default ProductCard;
